import React from 'react';

function ArrowCircleLeft({ fill, className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0001 18.9583C5.05842 18.9583 1.04175 14.9417 1.04175 9.99999C1.04175 5.05832 5.05842 1.04166 10.0001 1.04166C14.9417 1.04166 18.9584 5.05832 18.9584 9.99999C18.9584 14.9417 14.9417 18.9583 10.0001 18.9583ZM10.0001 2.29166C5.75008 2.29166 2.29175 5.74999 2.29175 9.99999C2.29175 14.25 5.75008 17.7083 10.0001 17.7083C14.2501 17.7083 17.7084 14.25 17.7084 9.99999C17.7084 5.74999 14.2501 2.29166 10.0001 2.29166Z"
        fill={`${fill}`}
      />
      <path
        d="M11.0499 13.5667C10.8916 13.5667 10.7333 13.5083 10.6083 13.3833L7.6666 10.4417C7.42493 10.2 7.42493 9.80001 7.6666 9.55834L10.6083 6.61667C10.8499 6.37501 11.2499 6.37501 11.4916 6.61667C11.7333 6.85834 11.7333 7.25834 11.4916 7.50001L8.9916 10L11.4916 12.5C11.7333 12.7417 11.7333 13.1417 11.4916 13.3833C11.3749 13.5083 11.2166 13.5667 11.0499 13.5667Z"
        fill={`${fill}`}
      />
    </svg>
  );
}

export default ArrowCircleLeft;
